@if (config(); as config) {

  <div class="wrapper">

    @if (config.header; as header) {

      <div class="form-header">

        <h2 class="title">{{header.title}}</h2>

        @if (header.hint; as hint) {
          <p class="hint">{{hint}}</p>
        }

      </div>

    }

    <div class="form-content">
      <ng-content select="[form-content]"></ng-content>
    </div>

    @if (!config.hideFooter) {

      <div class="form-footer">
        <ng-content select="[form-footer]"></ng-content>
      </div>

    }

    <ng-content></ng-content>

  </div>
}
